import { shallowEqual } from "react-redux";
import { type BuildAndBuyDispatchType, useBnbSelector } from "../../../redux/store";
import CarDataConsolidator from "../../../../../shared-logic/utils/classes/CarDataConsolidator";
import type { PackType } from "../../../../../../common-deprecated/types/CommonTypes";
import { removePack } from "../../../redux/actions/BasketActions";
import { useDispatch } from "../../../../../../shared-logic/redux/store";

type SummaryPackType = {
    packs: PackType[];
    removePack: (pack: PackType) => void;
};

const useSummaryPack = (): SummaryPackType => {
    const dispatch = useDispatch<BuildAndBuyDispatchType>();
    const packs = useBnbSelector(
        (state) => [...state.basket.packs, ...state.items.packs.filter((pack) => pack.standard)],
        shallowEqual,
    );
    const packExtras = useBnbSelector((state) => state.basket.packExtras);
    const upholsteries = useBnbSelector((state) => state.items.upholsteries);

    // Add the price of equipped pack extras to the pack price. PackExtra's are not rendered in summary.
    const mappedPacks: PackType[] = packs
        .map((pack) => {
            const packEquipmentIds = pack.equipment.map((equipment) => equipment.id);

            const packPrice = { ...pack.price };

            packExtras.forEach((packExtra) => {
                if (packEquipmentIds.includes(packExtra.id)) {
                    packPrice.cash += packExtra.price.cash;
                    packPrice.monthly += packExtra.price.monthly;
                    if (packPrice.discount) {
                        packPrice.discount += packExtra.price.cash;
                    }
                }
            });

            return { ...pack, price: packPrice };
            // also calculate in the accessory upholstery price when applicable
        })
        .map((pack) => {
            return { ...pack, price: CarDataConsolidator.getPackAccessoryUpholsteryPrice(pack, upholsteries) };
        });

    return {
        packs: mappedPacks,
        removePack: (pack: PackType) => {
            dispatch(removePack(pack, true));
        },
    };
};

export default useSummaryPack;
